import type { Mutation } from 'vuex'
import type { State } from './state'
import type {
  CartDocument,
  CartRecipient,
  Client,
  ConfirmPageInitErrorDatas,
  CorporateInfo,
  DeleteMultiCartDocument,
  DeleteMultiCartRecipient,
  RecipientClientDetail,
  RecipientClientList,
  RecipientMasterOptions,
  RecipientSelectCheckErrors,
  RecipientUserList,
} from '@/api/multi-send-cart/model/multiSendCartModel'
import type { FolderTree, FolderTreeItem } from '@/api/model/folderModel'

import actionTypes from './actionTypes'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  /** @description 送信カート 件数を設定する */
  [actionTypes.SET_MULTI_CARTS_COUNT](state, count: string | number): void {
    state.multiCartsCount = count
  },

  /** @description 送信カート 送信対象テーブルデータを設定する */
  [actionTypes.SET_SEND_CART_DOCUMENT](state, data: CartDocument): void {
    state.sendCartDocument = data
  },

  /** @description 送信対象 削除確認ダイヤログ画面表示フラグを設定する */
  [actionTypes.SET_MODAL_DELETE_SEND_DOCUMENT_ACTIVED](state, status: boolean): void {
    state.modalDeleteSendDocumentActived = status
  },

  /** @description 送信先 削除確認ダイヤログ画面表示フラグを設定する */
  [actionTypes.SET_MODAL_DELETE_SEND_RECIPIENT_ACTIVED](state, status: boolean): void {
    state.modalDeleteSendRecipientActived = status
  },

  /** @description 送信カートの送信メッセージを設定する */
  [actionTypes.SET_SEND_CART_MESSAGE](state, text: string): void {
    state.sendCartMessage = text
  },

  /** @description 送信カート 送信先テーブルデータを設定する */
  [actionTypes.SET_SEND_CART_RECIPIENT](state, data: CartRecipient): void {
    state.sendCartRecipient = data
  },

  /** @description 送信カート 送信先選択画面表示フラグを設定する */
  [actionTypes.SET_MODAL_RECIPIENT_SELECT_ACTIVED](state, status: boolean): void {
    state.modalRecipientSelectActived = status
  },

  /** @description 送信カート  全てのデータをクリアする確認ダイヤログ画面表示フラグを設定する */
  [actionTypes.SET_MODAL_CLEAR_SEND_CART_ACTIVED](state, status: boolean): void {
    state.modalClearSendCartActived = status
  },

  /** @description 送信カート  削除する送信先を設定する */
  [actionTypes.SET_DELETE_SEND_CART_RECIPIENT](state, target: DeleteMultiCartRecipient): void {
    state.deleteRecipientTarget = target
  },

  /** @description 送信カート  削除する送信対象を設定する */
  [actionTypes.SET_DELETE_SEND_CART_DOCUMENT](state, target: DeleteMultiCartDocument): void {
    state.deleteDocumentTarget = target
  },

  /** @description 送信先選択画面　送信先マスタoptionsを設定する */
  [actionTypes.SET_RECIPIENT_MASTER_OPTIONS](
    state,
    options: RecipientMasterOptions
  ): void {
    state.recipientMasterOptions = options
  },

  /** @description 送信先選択画面　取引先選択リスト　バックアップデータを設定する */
  [actionTypes.SET_RECIPIENT_CLIENT_LIST](state, list: RecipientClientList): void {
    state.recipientClientList = list
  },

  /** @description 送信先選択画面　取引先選択リスト　表示用データを設定する */
  [actionTypes.SET_DISPLAY_CLIENT_LIST](state, list: RecipientClientList): void {
    state.displayClientList = list
  },

  /** @description 送信先選択画面　選択した取引先情報を設定する  */
  [actionTypes.SET_SELECTED_CLIENT](state, selectedClient: Client): void {
    state.selectedClient = selectedClient
  },

  /** @description 送信先選択画面　法人情報を設定する */
  [actionTypes.SET_RECIPIENT_CORPORATE_INFO](state, corporateInfo: CorporateInfo): void {
    state.corporateInfo = corporateInfo
  },

  /** @description 送信先選択画面　担当者情報を設定する  */
  [actionTypes.SET_RECIPIENT_USER_LIST](state, recipientUserList: RecipientUserList): void {
    state.recipientUserList = recipientUserList
  },

  /** @description 送信先選択画面　担当者情報をクリアする  */
  [actionTypes.CLEAR_RECIPIENT_USER_LIST](state): void {
    state.recipientUserList = [] as RecipientUserList
  },

  /** @description 送信先選択画面　選択した担当者を設定する  */
  [actionTypes.SET_SELECTED_USER](state, selectedRecipientUser: RecipientClientDetail): void {
    state.selectedUser = selectedRecipientUser
  },

  /** @description 送信先選択画面　送信先フォルダ情報を設定する  */
  [actionTypes.SET_RECIPIENT_FOLDER_TREE_LIST](state, folderTreeList: FolderTree): void {
    state.recipientFolderTreeList = folderTreeList
  },

  /** @description 送信先選択画面　送信先フォルダ情報をクリアする  */
  [actionTypes.CLEAR_RECIPIENT_FOLDER_TREE_LIST](state): void {
    state.recipientFolderTreeList = [] as FolderTree
  },

  /** @description 送信先選択画面　選択した送信先フォルダを設定する  */
  [actionTypes.SET_SELECTED_FOLDER_TREE](state, selectedFolderTree: FolderTreeItem): void {
    state.selectedFolderTree = selectedFolderTree
  },

  /** @description 送信先選択画面 「追加する」ボタン押下後のチェックエラー */
  [actionTypes.SET_CHECK_ERRORS](state, checkErrors: RecipientSelectCheckErrors): void {
    state.checkErrors = checkErrors
  },

  /** @description 送信完了画面　表示フラグを設定する */
  [actionTypes.SET_MODAL_SEND_FINISHED_ACTIVED](state, status: boolean): void {
    state.modalSendFinishedActived = status
  },


  /** @description 送信カート確認画面　送信先チェックのエラーメーセージとレベルを設定する */
  [actionTypes.SET_CONFIRM_PAGE_INIT_ERROR_DATAS](state, datas: ConfirmPageInitErrorDatas): void {
    state.confirmPageInitErrorDatas = datas
  },

  [actionTypes.SET_SORT_COLUMN_EXIST](state, status: boolean): void {
    state.sortColumnExist = status
  },

  [actionTypes.SET_SORT_COLUMN_RECIPIENT_EXIST](state, status: boolean): void {
    state.sortColumnRecipientExist = status
  },
}

export default mutations
